(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ActiveUserController', ActiveUserController);


    ActiveUserController.$inject = ['$translate', '$timeout', 'Auth', 'PersonInfo', '$state', 'entity', 'LoginService'];

    function ActiveUserController($translate, $timeout, Auth, PersonInfo, $state, entity, LoginService) {
        var vm = this;


        vm.userName = entity;
        vm.doNotMatch = null;
        vm.error = null;
        vm.errorUserExists = null;
        vm.login = LoginService.open;
        vm.registerAccount = {};
        vm.success = null;
        vm.activatedSuccess = null;
        vm.activateUser = activateUser;
        vm.submited = submited;
        vm.formMode = 'ACTIVEUSER';
        vm.errorPhoneNumberExists = null;
        vm.regenerateActivationKey = regenerateActivationKey;
        vm.activatedSuccess = null;

        $timeout(function () {
            angular.element('#login').focus();
        });

        function submited() {
            if (vm.formMode == 'ACTIVEUSER') {
                activateUser();
            }
        }

        function activateUser() {
            //
            if (vm.key != null) {
                Auth.activateAccount(vm.userName, vm.key).then(function () {
                    //
                    vm.activateError = null;
                    vm.activatedSuccess = 'OK';

                }).catch(function () {
                    //
                    //vm.activatedSuccess = null;
                    //vm.activateError = 'ERROR';
                });
            } else {
                //
                vm.activatedSuccess = null;
                vm.activateError = 'ERROR';
            }

        }

        function regenerateActivationKey() {

            Auth.regenerateActivationKey(vm.userName)
                .then(function () {

                    vm.regenerateSuccess = 'OK';
                    vm.regenerateError = null;
                }).catch(function () {

                vm.regenerateSuccess = null;
                vm.regenerateError = 'ERROR';
            });
        }
    }
})();
